import { useQuery } from "@tanstack/react-query";
import { getAuthenticatedRequest } from "../utils/API/api.ts";

export const useFetchLeadsCount = ({ eventId }) => {
  return useQuery({
    queryKey: ["leadsCount", eventId],
    queryFn: async () => {
      const { data } = await getAuthenticatedRequest(
        `/attendee/getLeadCounts?eventId=${eventId}`
      );
      return data;
    },
    enabled: !!eventId,
    staleTime: 5 * 60 * 1000,
  });
};

export const useFetchUserRanking = ({ eventId }) => {
  return useQuery({
    queryKey: ["userRanking", eventId],
    queryFn: async () => {
      const { data } = await getAuthenticatedRequest(
        `/attendee/getUserRanking?eventId=${eventId}`
      );
      return data;
    },
    enabled: !!eventId,
    staleTime: 5 * 60 * 1000,
  });
};

export const useFetchLeads = ({ eventId, currentLead, page, searchValue }) => {
  return useQuery({
    queryKey: ["leads", eventId, currentLead, page, searchValue],
    queryFn: async () => {
      let url = "";
      if (searchValue && searchValue.trim() !== "") {
        url = `/attendee/searchLeads?eventId=${eventId}&search=${searchValue}&qualifiedAs=${currentLead}`;
      } else {
        url = `/attendee/getLeadDetails?eventId=${eventId}&filter=${currentLead}&page=${page}`;
      }
      const { data } = await getAuthenticatedRequest(url);
      return searchValue ? data.results : data.leads;
    },
    enabled: !!eventId,
    staleTime: 5 * 60 * 1000,
  });
};

export const useFetchCardLeads = ({ eventId, page, searchValue }) => {
  return useQuery({
    queryKey: ["cardLeads", eventId, page, searchValue],
    queryFn: async () => {
      let url = "";

      if (searchValue && searchValue.trim() !== "") {
        url = `/attendee/cardLeadSearch?eventId=${eventId}&search=${searchValue}`;
      } else {
        url = `/attendee/getCardLeads?eventId=${eventId}&page=${page}`;
      }
      const { data } = await getAuthenticatedRequest(url);
      return searchValue ? data?.results : data?.cardLeads;
    },
    enabled: !!eventId,
    staleTime: 5 * 60 * 1000,
  });
};
